package com.nnod.landing

import androidx.compose.runtime.Composable

@Composable
fun LandingPagesApp() {
    LandingApp()
}
